import CreateCustomShortCut from "@/features/financas/views/Indicadores/widgets/Preferencias/strategy/criar/CreateCustomShortcut";
import CreatePreferencias from "@/features/financas/views/Indicadores/widgets/Preferencias/strategy/criar/CreatePreferencias";
import PreferenciasTemplate from "@/features/financas/views/Indicadores/widgets/Preferencias/strategy/PreferenciasTemplate";
import PreferenciasDRE from "@/features/financas/views/Indicadores/widgets/DREPanel/PreferenciasDRE";
import PreferenciasPainelDeVendas from "@/features/financas/views/Indicadores/widgets/VendasPanel/preferencias/PreferenciasPanelDeVendas";
import { ContainerModule } from "inversify";
import { getActivePinia } from "pinia";
import PreferenciasFiltrosGerais from "../PreferenciasFiltrosGerais";
import PreferenciasFluxoDeCaixa from "@/features/financas/views/Indicadores/widgets/FluxoCaixaPanel/preferencias/PreferenciasFluxoDeCaixa";

const preferenciasContainer = new ContainerModule((bind) => {
  bind(PreferenciasTemplate)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasFiltrosGerais)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasPainelDeVendas)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasFluxoDeCaixa)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasDRE)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(CreatePreferencias)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(CreateCustomShortCut)
    .toSelf()
    .when(() => !!getActivePinia());
});

export { preferenciasContainer };
